// extracted by mini-css-extract-plugin
export default {"status":"styles_status__o7MP3","icon":"styles_icon__yhP52","info":"styles_info__qUEjg","countContainer":"styles_countContainer__MsfzT","newCount":"styles_newCount__7xFOU"};